/**
 * Config del SDK de Payway desde `.env` (variables `VITE_*`, resueltas al compilar).
 * Solo la API Key PÚBLICA: la privada es del backend y nunca va en este proyecto.
 * Cybersource queda deshabilitado (decisión ENA-1607); revisar antes de producción.
 */
import { PaymentError } from '../domain/errors';

export interface PaywayConfig {
  publicApiKey: string;
  apiUrl: string;
  sdkUrl: string;
  disableCybersource: boolean;
}

type EnvSource = Record<string, string | undefined>;

const REQUIRED = {
  publicApiKey: 'VITE_PAYWAY_PUBLIC_API_KEY',
  apiUrl: 'VITE_PAYWAY_API_URL',
  sdkUrl: 'VITE_PAYWAY_SDK_URL',
} as const;

/**
 * Lee SOLO las variables de Payway, por acceso estático. No pasar `import.meta.env` completo:
 * Vite lo incrustaría entero en el bundle (incluidas variables de `.env.local` como los tokens de
 * prueba del modo desarrollo).
 */
const readBuildEnv = (): EnvSource => ({
  VITE_PAYWAY_PUBLIC_API_KEY: import.meta.env.VITE_PAYWAY_PUBLIC_API_KEY,
  VITE_PAYWAY_API_URL: import.meta.env.VITE_PAYWAY_API_URL,
  VITE_PAYWAY_SDK_URL: import.meta.env.VITE_PAYWAY_SDK_URL,
});

export const readPaywayConfig = (env: EnvSource = readBuildEnv()): PaywayConfig => {
  const missing = Object.values(REQUIRED).filter((name) => !env[name]?.trim());
  if (missing.length > 0) {
    throw new PaymentError(`Missing Payway config: ${missing.join(', ')}`);
  }

  return {
    publicApiKey: env[REQUIRED.publicApiKey]!.trim(),
    apiUrl: env[REQUIRED.apiUrl]!.trim(),
    sdkUrl: env[REQUIRED.sdkUrl]!.trim(),
    disableCybersource: true,
  };
};
